import Vue from 'vue'
import App from './App.vue'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
import VueCurrencyInput from 'vue-currency-input'

Vue.config.productionTip = false

const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: 'HRK', locale: 'de' }
}
Vue.use(VueCurrencyInput, pluginOptions)
Vue.use(Chartkick.use(Chart))

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('hr-HR', {
    style: 'currency',
    currency: 'hrk',
  });
  return formatter.format(value);
});

Chart.defaults.global.defaultFontSize = 16;